import React from 'react';
import classNames from 'classnames';

const Item = (item) => {
  const classes = classNames({
    'c-localnav__list__item': true,
    'c-localnav__list__item--has-children': !!item.Children,
    'c-localnav__list__item--is-selected': item.IsCurrentPage,
    'c-localnav__list__item--is-open': item.ActivePath,
  });

  const secondLevel =
    item.Children &&
    item.Children.map((child, index) => (
      <li
        className={classNames({
          'c-localnav__list__item': true,
          'c-localnav__list__item--is-selected': child.IsCurrentPage,
        })}
        key={index}
      >
        <a href={child.Url}>
          <span>{child.Text}</span>
        </a>
      </li>
    ));

  return (
    <li className={classes}>
      <a href={item.Url}>
        <span>{item.Text}</span>
      </a>
      {item.Children && (
        <ul className="c-localnav__list__secondary">{secondLevel}</ul>
      )}
    </li>
  );
};

export default Item;
